// extracted by mini-css-extract-plugin
export default {"container":"TotalPrice_container__4163+","label":"TotalPrice_label__7mPdD","value":"TotalPrice_value__NQizb"};